  // Import the functions you need from the SDKs you need
  import { initializeApp } from 'firebase/app';
  import { getAnalytics, setUserProperties } from "firebase/analytics";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyDJaPVNxdEctD4FP2pOqqU7UTFKJ8CyPd8",
    authDomain: "parole-calc.firebaseapp.com",
    databaseURL: "https://parole-calc-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "parole-calc",
    storageBucket: "parole-calc.appspot.com",
    messagingSenderId: "671260320245",
    appId: "1:671260320245:web:3cf15f039254fae3a040bc",
    measurementId: "G-RJMMQYK9B7"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  setUserProperties(analytics, { app_version: '2.0.0' });

  export { app, analytics };